import { store } from '@platform/viewer';
import { redux } from '@platform/core';

/** Canonical key. Pass '' for any leg you don't have. Same shape as the old bridge. */
export function makeSuvKey(structureSetUID, roiNumber, ctSeriesUID) {
  return `${structureSetUID || ''}:${
    roiNumber == null ? '' : roiNumber
  }:${ctSeriesUID || ''}`;
}

/* ---- redux scalars ---- */

export function setSuvStats(key, stats) {
  if (!key) return;
  const action = redux.actions.setSuvEntry(key, stats);
  store.dispatch(action);
}

export function getSuvStats(key) {
  if (!key) return null;
  return store.getState().extensions.dicomRT.suvByKey?.[key] || null;
}

export function clearAllSuvStats() {
  store.dispatch(redux.actions.clearSuv());
}

/* ---- SUV-specific computing flag (separate from isComputing) ---- */

export function setSuvComputingFlag(bool) {
  store.dispatch(redux.actions.setSuvComputing(!!bool));
}

export function isSuvComputing() {
  return !!store.getState().extensions.dicomRT.suvComputing;
}

export function setPsmaEntries(psmaByKey, psmaThresholdsBySS) {
  store.dispatch(redux.actions.setPsmaEntries(psmaByKey, psmaThresholdsBySS));
}

export function getPsmaVolume(key) {
  if (!key) return null;
  return store.getState().extensions.dicomRT.psmaByKey?.[key] || null;
}

export function setBloodPoolRefs(bloodPoolBySS) {
  store.dispatch(redux.actions.setBloodPoolRefs(bloodPoolBySS));
}

export function getRoiSuvEntry(key) {
  const stats = getSuvStats(key);
  if (!stats || stats.ne) return { suv: null, psma_volume: null };
  return {
    suv: { max: stats.suvMax, mean: stats.suvMean, min: stats.suvMin, sd: stats.suvSD },
    psma_volume: getPsmaVolume(key),
  };
}

/** NE / not-evaluable scalar entry. */
export function makeNeStats(reason) {
  return {
    suvMax: null,
    suvMean: null,
    suvMin: null,
    suvSD: null,
    voxelCount: 0,
    ne: true,
    reason: reason || 'not-evaluable',
  };
}
